import React from 'react'
import { Link } from 'react-router-dom'

function AppUnavailableAlert(props) {

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className={props.style ? 'col-8 pd-t-50 d-flex flex-column' : ""}><div
                    className={props.style ? "card mg-b-20 pd-xs-x-40 pd-x-20 pd-y-30 rounded-10" : ""}
                    style={{
                        boxShadow: props.style ? '0 0 10px rgba(0,0,0,0.1)' : ""
                    }}
                ><h5 className="tx-center mg-b-20">{props.message ? props.message : "Application is under Maintenance! Please try again later."}</h5><div className="tx-center"><a onClick={props.handleClick?props.handleClick:""} ><button
                    type="button"
                    style={{ cursor: "pointer" }}
                    className={`btn btn-lg btn-primary `}
                >OK</button></a></div>
                </div>
                </div>
            </div>        </div>
    )
}

export default AppUnavailableAlert
